import { useMutation } from '@tanstack/react-query';
import type SharedSimple from '@/types/serializers/SharedSimple';

/** answer のファイル項目のファイルを CandidateProfile の document_files にアタッチする（既存 files API を利用） */
export default function useAttachFilesFromAnswer() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({
      candidateProfileId,
      candidateFormAnswerId,
    }: {
      candidateProfileId: number;
      candidateFormAnswerId: number;
    }) => {
      const formData = new FormData();
      formData.append('candidate_form_answer_id', String(candidateFormAnswerId));

      const response = await fetch(`/agent/api/candidate_profiles/${candidateProfileId}/files`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: formData,
      });

      const data: SharedSimple = await response.json();

      if (!response.ok || !data.success) {
        const errorMessage =
          (data as { error?: string }).error || 'ファイルのアタッチに失敗しました';
        const error = new Error(errorMessage);
        (error as Error & { apiMessage?: string }).apiMessage = errorMessage;
        throw error;
      }

      return data;
    },
  });
}
